import { isEmpty } from "lodash"
import { useEffect } from "react"
import PropTypes from "prop-types"
import { DATE, DROPDOWN_OPTION } from "helpers/shapes"
import Results from "modules/securities-finder-results"
import Facets from "modules/securities-finder-facets"
import SecuritiesSearchParameters from "modules/securities-search-parameters"
import { getDefaultSingleDateProps } from "helpers/shareMyView"

const DEFAULT_FILTER = { marketCapitalization: { gt: 500000000 } }

function MarketToolsSecuritiesFinder(props) {
  const { filter, setFilter, resetFilterSaver, setShareMyViewProps, selectedDate } = props

  useEffect(() => {
    if (!isEmpty(filter)) {
      return
    }

    resetFilterSaver()
    setFilter(DEFAULT_FILTER)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setShareMyViewProps(getDefaultSingleDateProps(selectedDate))
  }, [selectedDate, setShareMyViewProps])

  function handleSetSelectedColumns(columns, modelId) {
    const { setSelectedColumns, accountId } = props
    setSelectedColumns(columns, modelId, accountId)
  }

  return (
    <div className="modules_market-tools-securities-finder">
      <SecuritiesSearchParameters
        filter={props.filter}
        portfoliosList={props.portfoliosList}
        watchlistsList={props.watchlistsList}
        swapsList={props.swapsList}
        etfsList={props.etfsList}
        indexesList={props.indexesList}
        startDate={props.startDate}
        endDate={props.endDate}
        selectedDate={props.selectedDate}
        unmodeledDates={props.unmodeledDates}
        setDate={props.setDate}
        heapAddFilterId="screener-filter-add"
        account={props.account}
        modelId={props.modelId}
        noDateSelection={props.noDateSelection}
        allowFiltersToggle={props.allowFiltersToggle}
        context={props.context}
        instrumentPortfolio={props.instrumentPortfolio}
        currency={props.currency}
        isHistoricalFactorSensitivityAvailable={props.isHistoricalFactorSensitivityAvailable}
        selectedDateAdjusted={props.selectedDateAdjusted}
        updateFilters={props.updateFilters}
        setFilter={props.setFilter}
      />
      <div className="results">
        <Facets
          selectedDate={props.selectedDate}
          modelId={props.modelId}
          currency={props.currency}
          filter={props.filter}
          filterId={props.filterId}
          toggleFacet={props.toggleFacet}
          toggleClassificationFacets={props.toggleClassificationFacets}
          selectedCountries={props.selectedCountries}
          selectedCurrencies={props.selectedCurrencies}
          selectedClassifications={props.selectedClassifications}
        />
        <Results
          selectedDate={props.selectedDate}
          modelId={props.modelId}
          currency={props.currency}
          isHistoricalFactorSensitivityAvailable={props.isHistoricalFactorSensitivityAvailable}
          filter={props.facetedFilter}
          filterId={props.facetedFilterId}
          setSort={props.setSort}
          selectedSort={props.sort}
          setPage={props.setPage}
          page={props.page}
          setSelectedColumns={handleSetSelectedColumns}
          selectedColumns={props.selectedColumns}
        />
      </div>
    </div>
  )
}

MarketToolsSecuritiesFinder.propTypes = {
  selectedDate: DATE.isRequired,
  filter: PropTypes.object,
  filterId: PropTypes.string,
  setFilter: PropTypes.func.isRequired,
  resetFilterSaver: PropTypes.func.isRequired,
  modelId: PropTypes.string.isRequired,
  portfoliosList: PropTypes.arrayOf(DROPDOWN_OPTION),
  watchlistsList: PropTypes.arrayOf(DROPDOWN_OPTION),
  etfsList: PropTypes.arrayOf(DROPDOWN_OPTION),
  swapsList: PropTypes.arrayOf(DROPDOWN_OPTION),
  indexesList: PropTypes.arrayOf(DROPDOWN_OPTION),
  unmodeledDates: PropTypes.objectOf(PropTypes.bool),
  facetedFilter: PropTypes.object,
  facetedFilterId: PropTypes.string,
  endDate: DATE,
  startDate: DATE,
  setDate: PropTypes.func.isRequired,
  setSort: PropTypes.func.isRequired,
  sort: PropTypes.object,
  setPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  account: PropTypes.string.isRequired,
  noDateSelection: PropTypes.bool,
  allowFiltersToggle: PropTypes.bool,
  context: PropTypes.string,
  instrumentPortfolio: PropTypes.object,
  currency: PropTypes.string,
  isHistoricalFactorSensitivityAvailable: PropTypes.bool,
  selectedCountries: PropTypes.object,
  selectedCurrencies: PropTypes.object,
  selectedClassifications: PropTypes.object,
  toggleFacet: PropTypes.func.isRequired,
  toggleClassificationFacets: PropTypes.func.isRequired,
  setSelectedColumns: PropTypes.func.isRequired,
  selectedColumns: PropTypes.objectOf(PropTypes.bool).isRequired,
  selectedDateAdjusted: PropTypes.bool,
  setShareMyViewProps: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
  updateFilters: PropTypes.func.isRequired,
}

export default MarketToolsSecuritiesFinder
